const ns = "ANALYTICS";
export const TRACK = `${ns}_TRACK`;
